import { ENActionType } from './types/en-action-type';

/**
 * Gets the type of the current EN action
 */
export const getActionType = () => window.pageJson.pageType as ENActionType;

/**
 * Get the campaign ID of the current EN action
 */
export const getCampaignId = () => window.pageJson.campaignId;
